import React from 'react';
import CardSocialRender from './CardSocialRender';

export const CardSocial = ():JSX.Element => {

	return <CardSocialRender/>;
};